import { render } from "./MapIcon.vue?vue&type=template&id=3df31db8"
import script from "./MapIcon.vue?vue&type=script&lang=js"
export * from "./MapIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__